'use client'

import {useTranslations} from 'next-intl'
import {Columns3} from 'lucide-react'
import {COMPARE_MAX, useCompareList} from './useCompareList'

/** "Compare" on a search result: adds it to the picks the compare bar holds. */
export function CompareToggle({slug, name}: {slug: string; name: string}) {
  const t = useTranslations('compare')
  const {items, toggle} = useCompareList()
  const picked = items.some((item) => item.slug === slug)
  const full = !picked && items.length >= COMPARE_MAX

  return (
    <button
      type="button"
      className="u-btn u-btn--ghost u-btn--sm u-compare-toggle"
      aria-pressed={picked}
      // Not `disabled`: a disabled button can't be focused to hear why.
      aria-disabled={full || undefined}
      aria-label={t(picked ? 'toggleRemove' : 'toggleAdd', {name})}
      title={full ? t('toggleFull', {max: COMPARE_MAX}) : undefined}
      onClick={() => {
        if (!full) toggle({slug, name})
      }}
      data-testid={`compare-${slug}`}
    >
      <Columns3 aria-hidden="true" size={16} />
      {t(picked ? 'toggleOn' : 'toggleOff')}
    </button>
  )
}
